import type { GlobalLoginFormStoryblok, PartialLoginBoxScreenDescriptionStoryblok } from '@/types/component-types-sb';

import { ScreensetScreens } from './types';

/** Reiner Login-Screen: nur im laufenden OIDC-Kontext (nicht per direkter URL „schön“ bedienen). */
export function isLoginScreenOidcOnly(screen: ScreensetScreens): boolean {
  return screen === ScreensetScreens.LOGIN_SCREEN;
}

/** Maps SAP CDC `onOidc` `params.mode` to the screenset screen we intend to show. */
export function oidcModeMatchesScreen(mode: string | undefined, screen: ScreensetScreens): boolean {
  if (!mode) {
    return false;
  }
  const m = mode.toLowerCase();
  switch (screen) {
    case ScreensetScreens.LOGIN_SCREEN:
      return m === 'login';
    case ScreensetScreens.REGISTER_SCREEN:
      return m === 'register' || m === 'registration';
    case ScreensetScreens.AMNESIA_SCREEN:
      return m === 'forgotpassword' || m === 'forgot-password' || m === 'amnesia';
    case ScreensetScreens.RESET_PASSWORD_SCREEN:
      return m === 'reset' || m === 'resetpassword' || m === 'password-reset';
    default:
      return false;
  }
}

export const modeScreenMapping: Record<string, ScreensetScreens> = {
  ['']: ScreensetScreens.LOGIN_SCREEN,
  ['login']: ScreensetScreens.LOGIN_SCREEN,
  ['password-reset']: ScreensetScreens.RESET_PASSWORD_SCREEN,
  ['register']: ScreensetScreens.REGISTER_SCREEN,
  ['amnesia']: ScreensetScreens.AMNESIA_SCREEN,
};

export function metaTitleResolver(key: string): string {
  switch (key) {
    case ScreensetScreens.LOGIN_SCREEN:
      return 'Anmelden';
    case ScreensetScreens.REGISTER_SCREEN:
      return 'Registrieren';
    case ScreensetScreens.AMNESIA_SCREEN:
      return 'Passwort vergessen';
    case ScreensetScreens.RESET_PASSWORD_SCREEN:
      return 'Passwort zurücksetzen';
    default:
      return '';
  }
}

export function textResolver(
  key: string,
  blok: GlobalLoginFormStoryblok
): PartialLoginBoxScreenDescriptionStoryblok | undefined {
  switch (key) {
    case ScreensetScreens.LOGIN_SCREEN:
      return blok.text_login_screen?.at(0);
    case ScreensetScreens.REGISTER_SCREEN:
      return blok.text_registration_screen?.at(0);
    case ScreensetScreens.AMNESIA_SCREEN:
      return blok.text_amnesia_screen?.at(0);
    case ScreensetScreens.RESET_PASSWORD_SCREEN:
      return blok.text_reset_password_screen?.at(0);
    default:
      return blok.text_login_screen?.at(0);
  }
}
